import React from 'react';
import PropTypes from "prop-types";
import styles from './ServiceCallsTable.module.scss';
import moment from "moment";
import _ from "lodash";
import { $t } from "../../helpers/translator";
import api from "../../helpers/api";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import TimePeriodSelector from "../miscellaneous/TimePeriodSelector/TimePeriodSelector";
import DataTable from "../miscellaneous/DataTable/DataTable";
import { Link } from "react-router-dom";
import Modal from "../miscellaneous/Modal/Modal";
import CreateUserServiceCall from "../CreateUserServiceCall/CreateUserServiceCall";
import { connect } from "react-redux";
import { setAlert } from "../../store/alerts-slice";
import DOMPurify from "dompurify";
import { getClinics } from "../../store/data-slice";
import Input from "../miscellaneous/Input/Input";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import Timestamp from "../miscellaneous/Timestamp/Timestamp";
import HasPermission from '../../helpers/permissions/HasPermission';


class ServiceCallsTable extends React.Component {
    static propTypes = {
        /** Type of user connected to SmartClinic. used for routing links. (2: clinic, 3: chain) */
        userType: PropTypes.number,
        /** For presenting a specific clinic data. selection of clinic will be disabled. */
        clinicId: PropTypes.number,
        /** For presenting a specific patient data. */
        platformId: PropTypes.number,
        /** Header of table. Fallbacks to 'Treatments' */
        applicatorId: PropTypes.number,
        /** Header of table. Fallbacks to 'Treatments' */
        header: PropTypes.string,
    }
    static defaultProps = {
        userType: 2,
        clinicId: 0,
        platformId: 0,
        applicatorId: 0,
        header: $t('global.menu.serviceCalls')
    }

    constructor(props) {
        super(props);

        this.state = {
            tableLoading: false,
            payload: {
                clinicId: this.props.clinicId ? this.props.clinicId : '',
                status: 0,  //open calls
                startDate: moment().subtract(1, 'year'),
                endDate: moment(),
                sort: 'id',
                order: 'desc',
                search: '',
                applicatorId: '',
                platformId: '',
                page: 1,
                per_page: 10,
            },
            pagination: null,
            data: [],

            serviceCallTextModal: '',

            clinicOptions: [ {
                label: $t('global.service.allClinics'), value: ''
            }, ],
            selectedClinicOption: [ {
                label: $t('global.service.allClinics'), value: ''
            }, ],

            statusOptions: [
                { label: $t('global.service.all'), value: '' },
                { label: $t('global.service.open'), value: 0 },
                { label: $t('global.service.closed'), value: 1 },
            ],
            selectedStatusOption: [ { label: $t('global.service.open'), value: 0 } ],

            showOpenServiceCallModal: false,
            resetKey: 1,
        };
    }

    async componentDidMount() {
        await this.getClinics();
        await this.getServiceCallsList();
    }

    async getClinics() {
        if (this.state.clinicId) {
            return;
        }

        let res = await this.props.dispatch(getClinics());

        let clinics = [ ...res ];
        clinics.unshift({
            value: '',
            label: $t('global.service.allClinics'),
        })
        this.setState({ clinicOptions: clinics });
    }

    getAPIUrl() {
        let payload = { ...this.state.payload };
        payload.startDate = moment(payload.startDate).format('YYYY-MM-DD');
        payload.endDate = moment(payload.endDate).format('YYYY-MM-DD');
        return `service/user?&clinic_id=${payload.clinicId}&status=${payload.status}&sort=${payload.sort}&order=${payload.order}&search=${payload.search}&page=${payload.page}&per_page=${payload.per_page}&startDate=${payload.startDate}&endDate=${payload.endDate}`
    }

    async getServiceCallsList() {
        this.setState({ tableLoading: true }, async () => {
            try {
                let res = await api.get(this.getAPIUrl());
                let pagination = null;
                let data = [];

                if (res && res.status === 200 && res.data.data) {
                    data = this.restructureData(res.data.data.data);
                    pagination = res.data.data.pagination;

                    this.setState({ platforms: [], pagination: pagination }, () => {
                        this.setState({
                            data: data,
                            pagination: pagination
                        });
                    })
                }
            } catch (e) {
                console.error('err get platforms:', e);
            } finally {
                this.setState({ tableLoading: false });
            }
        });
    }

    restructureData(data) {
        let userTypeName = this.props.userType === 2 ? 'clinic' : 'chain';

        _.forEach(data, (v, k) => {
            // v.created_at = (moment.utc(v.created_at).local()).format('YYYY-MM-DD HH:mm:ss');
            v.created_at = <Timestamp time={ v.created_at } />
            v.delete = <div>delete</div>
            v.platform_id = v.platform_db_id ? <Tooltip content={ v.platform_id }><Link to={ `/equipment/platform/${v.platform_db_id}` }>{ v.platform_name }</Link></Tooltip> : '';
            v.applicator_id = v.applicator_db_id ? <Tooltip content={ v.applicator_id }>{ v.applicator_serial_number ? v.applicator_serial_number : v.applicator_id }</Tooltip> : '';
            // v.applicator_id = v.applicator_serial_number ? v.applicator_serial_number : v.applicator_id;

            // v.platform_link = v.platform_db_id ?
            //     <Link to={`/equipment/platform/${v.platform_db_id}`}>{v.platform_id}</Link> : '';
            v.clinic_name = v.clinic_id ? <Link to={ `/clinic/${v.clinic_id}` }>{ v.clinic_name }</Link> : '';

            v.is_system_down = v.is_system_down ? $t('global.service.down') : $t('global.service.operational')

            v.fullText = v.text
            v.strippedText = v.fullText.replace(/<[^>]*>?/gm, '');
            v.text_link = <div className={ `alma-link` }
                onClick={ () => this.setState({
                    serviceCallTextModal: <div
                        dangerouslySetInnerHTML={ { __html: DOMPurify.sanitize(v.fullText) } } />
                }) }>{ $t('global.service.showMessage') }</div>
            v.statusId = v.status;
            v.status = v.statusId === 0 ?
                <div className={ styles.red }>{ $t('global.service.open') }</div>
                :
                <div className={ styles.green }>{ $t('global.service.closed') }</div>

            v.statusChange = <div>
                {
                    v.statusId === 0 ?
                        <div key={ 0 }><Tooltip content={ $t('global.service.closeExplained') }><Link to="#" onClick={ () => this.changeServiceCallStatus(v.id, 1) }>{ $t('global.service.close') }</Link></Tooltip></div>
                        :
                        <div key={ 1 }><Tooltip content={ $t('global.service.openExplained') }><Link to="#" onClick={ () => this.changeServiceCallStatus(v.id, 0) }>{ $t('global.service.open') }</Link></Tooltip></div>
                }
            </div>
        });
        return data;
    }


    dataTableActionHandler(data) {
        // console.log('dataTableActionHandler', data)
        if (data.key === 'page') {
            let payload = { ...this.state.payload };
            payload.page = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getServiceCallsList();
            });
        } else if (data.key === 'header') {
            let payload = { ...this.state.payload };
            payload.page = 1;

            if (payload.sort === data.value) {
                payload.order = payload.order === 'desc' ? 'asc' : 'desc';
            }
            payload.sort = data.value;

            this.setState({ payload: payload }, async () => {
                await this.getServiceCallsList();
            });
        }
    }

    async changeServiceCallStatus(id, status) {
        try {
            let res = await api.post(`/service/user/status`, {
                id: id,
                status: status
            })
            if (res.success) {
                await this.getServiceCallsList();
                await this.props.dispatch(setAlert({ type: 'success' }));
                return;
            }
            await this.props.dispatch(setAlert({ type: 'error' }));
        } catch (e) {
            await this.props.dispatch(setAlert({ type: 'error' }));
        }
        // let res = await api.post(`/service/user/status`, {
        //     id: id,
        //     status: status
        // })
        // if (res && res.status === 200) {
        //     await this.getServiceCallsList();
        //     await this.props.dispatch(setAlert({type: 'success'}));
        // } else {
        //     await this.props.dispatch(setAlert({type: 'error'}));
        // }
    }

    datesChangeHandler(data) {
        let payload = { ...this.state.payload };
        payload.startDate = data.startDate;
        payload.endDate = data.endDate;
        payload.page = 1;

        this.setState({ payload: payload }, async () => {
            await this.getServiceCallsList();
        });
    }

    searchHandler(e) {
        let payload = { ...this.state.payload };
        payload.search = e.target.value;
        payload.page = 1;

        this.setState({ payload: payload }, async () => {
            await this.getServiceCallsList();
        });
    }

    selectChangeHandler(name, data) {
        let payload = { ...this.state.payload };
        let selectedClinicOption = { ...this.state.selectedClinicOption };
        let selectedStatusOption = { ...this.state.selectedStatusOption };

        if (name === 'clinic') {
            payload.page = 1;
            payload.clinicId = data.value;
            selectedClinicOption = data;
        }

        if (name === 'status') {
            payload.status = data.value;
            payload.page = 1;
            selectedStatusOption = data;
        }

        // console.log(selectedClinicOption, selectedErrorTypeOption)

        this.setState({
            payload: payload,
            selectedClinicOption: selectedClinicOption,
            selectedStatusOption: selectedStatusOption
        }, async () => {
            await this.getServiceCallsList();
        });
    }

    closeModals() {
        this.setState({
            // showContactUsModal: false,
            serviceCallTextModal: '',
            showOpenServiceCallModal: false
        });
    }


    render() {
        let tableLoading = this.state.tableLoading;
        let data = this.state.data;
        let pagination = this.state.pagination;
        let tableSorted = {
            id: this.state.payload.sort,
            desc: this.state.payload.order === 'desc'
        }

        let tableHeaders = [
            {
                name: $t('global.service.status'),
                id: 'status',
                clickable: true
            },
            (!this.props.clinicId && this.props.userType === 4 ?
                {
                    name: '',
                    id: 'statusChange',
                    clickable: false
                }
                :
                null
            ),
            {
                name: $t('global.service.dateAndTime'),
                id: 'created_at',
                clickable: true
            },
            {
                name: $t('global.service.clinic'),
                id: 'clinic_name',
                clickable: true
            },

            {
                name: $t('global.service.systemStatus'),
                id: 'is_system_down',
                clickable: true
            },

            {
                name: $t('global.service.platform'),
                id: 'platform_id',
                clickable: true
            },
            {
                name: $t('global.service.applicator'),
                id: 'applicator_id',
                clickable: true
            },
            {
                name: $t('global.service.text'),
                accessor: 'text',
                id: 'text_link',
                clickable: false
            },

            {
                name: $t('global.service.serviceNumber'),
                id: 'service_call_number',
                clickable: true
            },
            {
                name: $t('global.service.serviceCall.phoneNumber'),
                id: 'submitter_phone_number',
                clickable: false
            },
            {
                name: $t('global.service.serviceCall.email'),
                id: 'submitter_email',
                clickable: false
            },
            {
                name: $t('global.service.serviceCall.name'),
                id: 'submitter_name',
                clickable: false
            },
        ];
        //
        // if (this.props.clinicId || this.props.userType === 2) {
        //     tableHeaders.splice(1, 1);
        // }

        return (
            <div className={ 'container' }>
                {/*<div>*/ }
                {/*    <div>*/ }
                {/*        {moment().format('YYYY-MM-DD HH:mm:ss')}*/ }
                {/*    </div>*/ }
                {/*    <div>*/ }
                {/*        /!*{localTime(moment())}*!/*/ }
                {/*    </div>*/ }
                {/*</div>*/ }

                <div className={ 'box' }>
                    <div className={ 'alma-box' }>
                        <div className={ 'alma-box-header' }>
                            <div>
                                <h3 id="serviceCallsTableHeader">{ this.props.header }</h3>
                            </div>
                            { this.props.userType < 4 ?
                                <HasPermission permission="service.create">
                                    <div className={ `alma-button ${styles[ 'button' ]}` }
                                        onClick={ () => this.setState({ showOpenServiceCallModal: true }) }
                                    >
                                        { $t('global.service.openServiceCall') }
                                    </div>
                                </HasPermission>
                                :
                                null }
                        </div>
                        <div className={ 'alma-fields-row' }>
                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.staff.selectTimePeriod') }:</div>
                                <TimePeriodSelector startDate={ this.state.payload.startDate }
                                    endDate={ this.state.payload.endDate }
                                    maxDate={ this.state.payload.startDate }
                                    hideQuarters
                                    onDatesChange={ this.datesChangeHandler.bind(this) } />
                            </div>
                            {
                                !this.props.clinicId && !this.props.platformId && this.props.userType !== 2 ?
                                    <div className={ 'alma-field-container' }>
                                        <div className={ 'alma-field-header' }>{ $t('global.service.byClinic') }</div>
                                        <MultiSelect
                                            options={ this.state.clinicOptions }
                                            selected={ this.state.selectedClinicOption }
                                            onValueChange={ (data) => this.selectChangeHandler('clinic', data) }
                                        />
                                    </div>
                                    :
                                    null
                            }
                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.service.byStatus') }</div>
                                <MultiSelect
                                    options={ this.state.statusOptions }
                                    selected={ this.state.selectedStatusOption }
                                    onValueChange={ (data) => this.selectChangeHandler('status', data) }
                                />
                            </div>

                            <div className={ 'alma-field-container' }>
                                <div className={ 'alma-field-header' }>{ $t('global.service.search') }</div>
                                <Input name="search"
                                    delay={ 500 }
                                    // disabled={tableLoading}
                                    className={ `${'alma-input'}` }
                                    type="text"
                                    value={ this.state.payload.search }
                                    placeholder={ $t('global.service.searchForServiceCall') }
                                    onChange={ (e) => this.searchHandler(e) } />
                            </div>
                        </div>
                        <div>
                            <DataTable data={ data }
                                // childrenArrayName={'treatments'}
                                headers={ tableHeaders }
                                pagination={ pagination }
                                loading={ tableLoading }
                                sorted={ tableSorted }
                                apiUrl={ this.getAPIUrl() }
                                onAction={ (e) => this.dataTableActionHandler(e) }
                            />
                        </div>

                        <Modal content={
                            <div className={ `${styles.serviceCallText}` }>
                                { this.state.serviceCallTextModal }
                            </div>
                        }
                            onClose={ () => this.closeModals() }
                            visible={ this.state.serviceCallTextModal } />

                        <Modal content={ <CreateUserServiceCall
                            key={ this.state.resetKey }
                            userType={ 3 }
                            onScreen={ this.state.showOpenServiceCallModal }
                            onClose={ async () => {
                                this.closeModals();
                                await this.setState({ resetKey: this.state.resetKey + 1 })
                                await this.getServiceCallsList()
                            } } /> }
                            onClose={ () => this.closeModals() }
                            visible={ this.state.showOpenServiceCallModal }
                        />


                    </div>
                </div>

            </div>
        );
    }
}


// export default ServiceCallsTable;

const mapStateToProps = (state) => ({
    state: state
});

export default connect(mapStateToProps)(ServiceCallsTable);
